"use client";

import * as React from 'react';
var context = /*#__PURE__*/React.createContext(null);
context.displayName = 'InputGroupContext';
export default context;